import React from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'

import { PortfolioList } from '@/components'
import { Header } from '@/modules/header'
import { routes } from '@/router'
import { ResourceType } from '@/schemas'
import { ga, traceEvent } from '@/utils/ga'

import { PortfolioCreateContainer } from './portfolio-create'
import { PortfolioDetailContainer } from './portfolio-detail'

export const PortfolioContainer = () => {
  React.useEffect(() => {
    ga('event', traceEvent.navigation.events.show_navigation, {
      event_category: traceEvent.navigation.event_categories.ef_pmo,
      event_label: traceEvent.navigation.event_labels.portfolios,
      action: traceEvent.navigation.action,
    })
  }, [])

  return (
    <Switch>
      <Route exact path={routes.portfolio.create()} component={PortfolioCreateContainer} />
      <Route exact path={routes.portfolio.page(':portfolioId')} component={PortfolioDetailContainer} />
      <Route
        exact
        path={routes.portfolio.home()}
        render={() => (
          <>
            <Header resourceType={ResourceType.PORTFOLIO} />
            <PortfolioList isReplaceRouter={true} />
          </>
        )}
      />
      <Redirect to={routes.portfolio.home()} />
    </Switch>
  )
}
